module.exports = __webpack_public_path__ + "static/media/katalog.d7bd3371.pdf";